// extracted by mini-css-extract-plugin
export default {"ActionBarWrapper":"📚19-10-2Dtcu5"};